import campaignConfig from '@config/campaign'

class SubmissionClient {
  public async createSubmission(content: any): Promise<any> {
    const url = `${campaignConfig.submissionUri}/submission/?campaignId=${encodeURIComponent(
      campaignConfig.campaignId
    )}`

    const response = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        campaignId: campaignConfig.campaignId,
        formSubmitTime: Date.now(),
        ...content,
      }),
      method: 'POST',
    })

    return response.status === 200 ? response.json() : Promise.reject(response)
  }

  public async captureInformationRequest(claimId: string, signature: string, information: any): Promise<any> {
    const url = `${campaignConfig.submissionUri}/captureAdditionalInformation`
    const response = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        campaignId: campaignConfig.campaignId,
        claimId,
        signature,
        information,
      }),
      method: 'PUT',
    })
    return response.status === 204 ? response : Promise.reject(response)
  }
}

export default new SubmissionClient()
